module.exports = __webpack_public_path__ + "img/proj7.0e13817c.png";